module.exports = __webpack_public_path__ + "static/media/site.68920204.webmanifest";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saleschannel-favicon/site.webmanifest
// module id = 275
// module chunks = 0